import React from "react";

import {IDatabaseField} from '../../../services/database';
import {Basic} from './Basic'
import {CustomOneSearch} from './CustomOne'

export interface CommonFormatterProps {
    id: string;
    layout: string;
    field: IDatabaseField;
    onChange: (key: string, value: string) => void; // <--- Function to call when value changes
}

export interface FormatterProps {
    id: string;
    field: IDatabaseField;
    query?:Record<string, string[]>;
    onChange: (key: string, value: string, allowMany?: boolean) => void; // <--- Function to call when value changes
}

export const CommonSearchFormatter: React.FC<CommonFormatterProps> = (props) => {
    // Example: check for the field type or any property
    const { layout, ...restProps } = props;

    if(layout === 'customOne')
        return (
            <CustomOneSearch {...restProps} />
        )

    // Default: render the custom one
    return <Basic {...restProps} />;
};








// WEBPACK FOOTER //
// ./src/public/search/layout/Common.tsx